// Titik trail terdekat dari satu waktu.

// eslint-disable-next-line import/prefer-default-export
export function nearestTrailPoint(points, ms, toleranceMs = 3600000) {
  if (!Array.isArray(points) || points.length === 0) return null;
  const target = Number(ms);
  if (!Number.isFinite(target)) return null;

  let low = 0;
  let high = points.length - 1;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (Number(points[mid].timestamp) * 1000 < target) low = mid + 1;
    else high = mid;
  }

  const candidate = [points[low]];
  if (low > 0) candidate.push(points[low - 1]);

  let best = null;
  let bestDistance = Infinity;
  candidate.forEach((points) => {
    const distance = Math.abs(Number(points.timestamp) * 1000 - target);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = points;
    }
  });

  return bestDistance <= Number(toleranceMs) ? best : null;
}
